import { render } from "./amendment.vue?vue&type=template&id=5b0d1dc9&scoped=true"
import script from "./amendment.vue?vue&type=script&lang=js"
export * from "./amendment.vue?vue&type=script&lang=js"

import "./amendment.vue?vue&type=style&index=0&id=5b0d1dc9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0d1dc9"]])

export default __exports__